<template>
  <div>
    <a href="#"><span class="c-blue-text tw-underline" @click="dialog = true">EDIT QUOTE</span></a>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card class="tw-py-3 md:tw-py-8">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-xl c-blue-text title-font tw-text-center tw-pb-3 md:tw-pb-8">Select the Inpatient Plan of your choice</h3>
          <div class="tw-flex tw-justify-center">
            <Inpatient />
          </div>
          <div class="tw-flex tw-justify-center tw-mt-4 md:tw-my-10">
            <AdditionalBenefits :is-edit="true" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Inpatient from '@/components/rfq/health/components/Inpatient';
import AdditionalBenefits from '@/components/rfq/health/AdditionalBenefits';

export default {
  name: 'InpatientEdit',
  components: { AdditionalBenefits, Inpatient },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    this.$root.$on('health-edit-modal-closed', () => {
      this.dialog = false;
    });
  },
};
</script>
